import {useMemo, useState} from "react";
import {Button, Dropdown, Form} from "react-bootstrap";

export const SCHEDULER_REGIONS_STORAGE_KEY = "schedulerSelectedRegions";

function readStoredRegions() {
    try {
        const value = sessionStorage.getItem(SCHEDULER_REGIONS_STORAGE_KEY);
        const parsed = value ? JSON.parse(value) : null;
        return Array.isArray(parsed) ? [...new Set(parsed.filter(value => typeof value === 'string' && value.trim()))] : null;
    } catch {
        return null;
    }
}

export default function RegionSelector({regions = [], selectedRegions = [], onChange}) {
    const [show, setShow] = useState(false);
    const selectedSet = useMemo(() => new Set(selectedRegions), [selectedRegions]);
    const label = selectedRegions.length === 0 || selectedRegions.length === regions.length
        ? "Region: All"
        : `Region: ${selectedRegions.length}`;

    return (
        <Dropdown className="scheduler-region-selector" show={show} onToggle={setShow} autoClose="outside">
            <Dropdown.Toggle as={Button} variant="outline-secondary" aria-label="Region selector" disabled={regions.length === 0}>
                {label}
            </Dropdown.Toggle>
            <Dropdown.Menu className="scheduler-region-menu">
                <Dropdown.Item as="button" type="button" onClick={() => onChange(regions)}>
                    Select all
                </Dropdown.Item>
                <Dropdown.Item as="button" type="button" onClick={() => onChange([])}>
                    Clear selection
                </Dropdown.Item>
                <Dropdown.Divider />
                {regions.map((region) => (
                    <div
                        key={region}
                        className="px-3 py-1"
                    >
                        <Form.Check
                            type="checkbox"
                            id={`scheduler-region-${region}`}
                            checked={selectedSet.has(region)}
                            onChange={() => onChange(selectedSet.has(region)
                                ? selectedRegions.filter((value) => value !== region)
                                : [...selectedRegions, region])}
                            label={region}
                        />
                    </div>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}

export function getStoredSchedulerRegions() {
    return readStoredRegions();
}

export function storeSchedulerRegions(regions) {
    try {
        sessionStorage.setItem(SCHEDULER_REGIONS_STORAGE_KEY, JSON.stringify(regions));
    } catch {
        // Session storage can be unavailable in private browsing or test environments.
    }
}
